module.exports = __webpack_public_path__ + "static/media/radarkontrolle.2881ec88.svg";